import { createSearchAsyncFn } from '@common/search.services';
import { envConfigs } from '@config/envConfigs';
import { apiServerGet } from '@common/axios.services';
import {
  IProjectDrawingSearchFilter,
  IProjectDrawingRegisterSearch,
  IProjectDrawingRegisterFilter,
  IProjectMasterScheduleDrawingRegisterSearchResult,
  IProjectDrawingHistoryRequest,
  IItemHistory,
} from './projectDrawingRegister.models';

export const apiRoutes = {
  drawingSearch: '/Drawings/Search',
  drawingRegister: '/Drawings/Register',
  drawingHistories: '/Drawings/Histories',
};

export const searchDrawingsAsync = createSearchAsyncFn<IProjectDrawingSearchFilter, IProjectDrawingRegisterSearch>(
  apiRoutes.drawingSearch,
);

export const searchDrawingRegisterAsync = createSearchAsyncFn<
  IProjectDrawingRegisterFilter,
  IProjectMasterScheduleDrawingRegisterSearchResult
>(apiRoutes.drawingRegister);

export const getDrawingHistoriesAsync = async (props: IProjectDrawingHistoryRequest): Promise<IItemHistory> => {
  const result = await apiServerGet<IItemHistory>(`${envConfigs.apiBaseUrl}${apiRoutes.drawingHistories}`, {
    params: {
      ...props,
    },
  });
  return result.data;
};
